import { requireAuth } from '@/functions';
import { companiesRouter } from '@/router/companies.router';
import { packagesRouter } from '@/router/packages.router';
import { productsRouter } from '@/router/products.router';
import HomeView from '@/views/home.view.vue';
import LoginView from '@/views/login.view.vue';
import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: '/autenticacao',
    name: 'auth',
    component: LoginView,
  },
  {
    path: '/',
    name: 'home',
    component: HomeView,
    beforeEnter: requireAuth,
    children: [
      ...companiesRouter,
      ...productsRouter,
      ...packagesRouter,
    ],
  },
];

const router: VueRouter = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;
